module.exports = __webpack_public_path__ + "img/wave-3.37742b9b.svg";